import React, { useState, useEffect } from "react";
import TableList from "./components/TableList";
import { createTableApi, updateTableApi, getTablesApi } from "./Api";
import { Link } from "react-router-dom";
import axios from "axios";

const CreateSeating = (props) => {
  const floorId = props.match.params.id;
  const floorName = props.match.params.name;
  const restaurantId = props.match.params.restaurantId;

  const [newFloorName, setNewFloorName] = useState("");
  const [isEditing, setisEditing] = useState(false);
  const [loading, setLoading] = useState(false);

  const [tableArray, setTableArray] = useState([
    {
      id: "654646546546",
      tableName: "First",
      capacity: 4,
      mergeable: true,
      currentStatus: "Empty",
    },
  ]);

  const [tableData, setTableData] = useState({
    tableName: "",
    capacity: "",
    mergeable: false,
    currentStatus: "Pending",
  });

  const getTables = async () => {
    setLoading(true);
    const res = await getTablesApi(floorId);
    console.log("Data is", res.data.data);
    setTableArray(res.data.data);
    setLoading(false);
  };

  const createTableFunc = async () => {
    setLoading(true);

    let dataToSend = {
      ...tableData,
      floorId: floorId,
      restaurantId: restaurantId,
    };

    const res = await createTableApi(dataToSend);

    const data = {
      duration: "60",
      id: restaurantId,
      table: res.data.data._id,
      weekdaysArr: [
        {
          days: ["monday", "tuesday", "wednesday", "thursday", "friday"],
          startTime: "08:00:00",
          endTime: "23:00:00",
          lunchStart: "12:00:00",
          lunchEnd: "15:00:00",
        },
      ],
    };
    await axios
      .post(
        "https://restoapp-super-admin.herokuapp.com/slots/generate-table-availability",
        data
      )
      .then((response) => {
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
    // setTableData({
    //     tableName : '',
    //     capacity : '',
    //     mergeable : false,
    //     currentStatus : ''
    // })
    setLoading(false);
    return getTables();
  };

  const updateFloorFunc = async () => {
    setLoading(true);
    const res = await updateTableApi(floorId, tableData);
    setLoading(false);
    return window.location.reload();
  };

  useEffect(() => {
    getTables();
    return () => {};
  }, [1]);

  return (
    <div className="p-8 w-full bg-gray-100 min-h-screen ">
      <div className="my-4 text-md font-semibold text-gray-600 flex items-center">
        <p>Tables For Floor : {floorName}</p>

        <Link to={`/seatlayout/${floorId}/${floorName}`}>
          <button className="bg-indigo-500 text-white px-4 ml-4 py-1 rounded-sm text-md">
            Map Layout
          </button>
        </Link>
      </div>

      <div className="w-full flex items-start justify-between">
        <div className="w-7/12 my-8">
          <TableList
            setisEditing={setisEditing}
            tableArray={tableArray}
            setTableData={setTableData}
          />
        </div>

        <div className="w-4/12 my-8">
          <div className="bg-white rounded-md border border-gray-100 py-4 px-2 pt-2 shadow-md ">
            <div className="my-4 w-full text-center text-md font-semibold text-gray-600">
              {" "}
              Table Form
            </div>

            <div className="w-90% mx-auto flex-1 svelte-1l8159u">
              <div>
                <p className="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase">
                  Table Name
                </p>
                <div className="bg-white my-4 p-1  border border-gray-200 rounded svelte-1l8159u">
                  <input
                    defaultValue={tableData.tableName}
                    onChange={(e) =>
                      setTableData({ ...tableData, tableName: e.target.value })
                    }
                    placeholder="Name of Table"
                    className="p-1 px-2 appearance-none outline-none w-full text-gray-800"
                  />
                </div>
              </div>

              <div>
                <p className="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase">
                  No. Of Seating
                </p>
                <div className="bg-white my-4 p-1  border border-gray-200 rounded svelte-1l8159u">
                  <input
                    defaultValue={tableData.capacity}
                    onChange={(e) =>
                      setTableData({ ...tableData, capacity: e.target.value })
                    }
                    placeholder="Seating of Table"
                    className="p-1 px-2 appearance-none outline-none w-full text-gray-800"
                  />
                </div>
              </div>

              <div>
                <p className="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase my-2">
                  Mergable
                </p>

                {tableData.mergeable ? (
                  <div
                    class="relative"
                    onClick={() => {
                      setTableData({ ...tableData, mergeable: false });
                    }}
                  >
                    <input
                      checked={tableData.mergeable}
                      id="toogleA"
                      type="checkbox"
                      class="sr-only"
                    />
                    <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                    <div class="dot absolute w-6 h-6 bg-green-400 rounded-full shadow left-4 -top-1  transition"></div>
                  </div>
                ) : (
                  <div
                    class="relative"
                    onClick={() => {
                      setTableData({ ...tableData, mergeable: true });
                    }}
                  >
                    <input
                      checked={tableData.mergeable}
                      id="toogleA"
                      type="checkbox"
                      class="sr-only"
                    />
                    <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                    <div class="dot absolute w-6 h-6 bg-gray-200 rounded-full shadow left-0 -top-1  transition"></div>
                  </div>
                )}
              </div>

              <div>
                <p className="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase">
                  Current Status
                </p>
                <div className="bg-white my-4 p-1  border border-gray-200 rounded svelte-1l8159u">
                  <input
                    defaultValue={tableData.currentStatus}
                    onChange={(e) => {
                      setTableData({
                        ...tableData,
                        currentStatus: e.target.value,
                      });
                    }}
                    placeholder="Status of Table"
                    className="p-1 px-2 appearance-none outline-none w-full text-gray-800"
                  />
                </div>
              </div>

              {isEditing ? (
                <div>
                  <span
                    onClick={() => {
                      setisEditing(false);
                      setNewFloorName("");
                    }}
                    className="mr-4 cursor-pointer text-red-400 text-md font-semibold hover:text-red-600"
                  >
                    Cancel
                  </span>
                  <button
                    onClick={() => updateFloorFunc()}
                    className="my-5  transition-all  bg-indigo-400 hover:bg-green-400 text-white px-4 py-2 rounded-md"
                  >
                    {loading ? "Updating...." : "Update Table"}
                  </button>
                </div>
              ) : (
                <button
                  onClick={() => createTableFunc()}
                  className="my-5  text-white px-4 py-2 transition-all  bg-indigo-400 hover:bg-green-400 rounded-md"
                >
                  {loading ? "Loading...." : "Create Table"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateSeating;

//Added the chnages
